<template>
	<div class="Layout">
		<Header></Header>
		<Map :facList="facList" :anjuanList="anjuanList" :zaixianList="zaixianList"></Map>
		<div class="map-left" ref="mapLeft">
			<LeftBox :zaixian="zaixian" :facList="facList" :anjuan="anjuan" @showVideoList="showVideoList">
				<template #leftImg>
					<img @click="leftClick(1)" src="@/assets/image/menuLeft.png" alt="" />
				</template>
			</LeftBox>
			<!-- <div class="map-info">
				<div class="map-info-title" :style="qar != 0 ? 'background: #03434F;' : ''" @click="danxuan('全部')">
					<div class="title-module">
						<img src="@/assets/image/mapinfo.png" alt="" class="title-module-img" />
						地图信息
					</div>
				</div>
				<div class="map-info-content" @click="danxuan('桥梁')" :style="qar == 1 ? 'background: #0d333a;' : ''">
					<div class="title-module">
						<img src="@/assets/image/huiqiaoliang.png" alt="" class="title-module-img" />
						桥梁
					</div>
					<div class="map-info-num">{{ fac }}</div>
				</div>
				<div class="map-info-content" @click="danxuan('在线人员')" :style="qar == 2 ? 'background: #0d333a;' : ''">
					<div class="title-module">
						<img src="@/assets/image/zaixianrenyuan.png" alt="" class="title-module-img" />
						在线人员
					</div>
					<div class="map-info-num">{{ zaixian }}</div>
				</div>
				<div class="map-info-content" @click="danxuan('案卷')" :style="qar == 3 ? 'background: #0d333a;' : ''">
					<div class="title-module">
						<img src="@/assets/image/anjuan.png" alt="" class="title-module-img" />
						案卷
					</div>
					<div class="map-info-num">{{ anjuan }}</div>
				</div>
			</div> -->
		</div>
		<div class="map-right" ref="mapRight">
			<RightBox>
				<template #leftImg>
					<img @click="leftClick(2)" src="@/assets/image/menuRight.png" alt="" />
				</template>
			</RightBox>
		</div>
		<Footer></Footer>
		<!--视频列表-->
		<videoList ref="videolist"></videoList>
	</div>
</template>

<script>
import Header from '@/views/components/new/Header.vue'
import Map from '@/views/components/Map.vue'
import LeftBox from './components/leftBox/index.vue'
import RightBox from './components/rightBox/index.vue'
import Footer from '@/views/components/new/Footer.vue'
import videoList from '@/views/components/videoList.vue'
export default {
	data() {
		return {
			left: 0,
			leftNum: 0,
			clickNum: 0,
			chooseNum: 1,
			listData: [],
			flagRight: false,
			facList: [],
			fac: 0,
			tableData: [],
			imgList: [],
			anjuanList: [],
			anjuan: 0,
			zaixianList: [],
			zaixian: 0,
			// loading
			loading: false,
			dataLangth: 15,
			timmerScrol: null,
			shenma: '全部',
			qar: 0,
			mapInfoData: [{ num: 365 }, { num: 24 }, { num: 132 }]
		}
	},
	computed: {
		optionSingleHeight1() {
			return {
				// singleHeight: 16,
				waitTime: 2500,
				step: 1,
				limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
				openWatch: false // 开启数据实时监控刷新dom
			}
		},
		defaultOption() {
			return {
				step: 0.4, // 数值越大速度滚动越快
				limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			}
		},
		optionLeft() {
			return {
				direction: 2,
				limitMoveNum: 1
			}
		}
	},
	components: {
		Header,
		Map,
		LeftBox,
		RightBox,
		Footer,
		videoList
	},

	mounted() {
		this.timechange()
		this.getFac()
		this.getzaixian()
		this.getanjuan()
		// 获取预警值列表
		// this.getSetUpEarlyWarning()
		clearInterval(this.timmerScrol)
		this.timmerScrol = null
		// this.timmerScrol = setInterval(() => {
		// 	// this.getSetUpEarlyWarning()
		// 	this.danxuan()
		// }, 60000)
	},
	methods: {
		leftClick(num) {
			if (num == 1) {
				let left = this.$refs.mapLeft.style.left
				if (left == '-4rem') {
					this.$refs.mapLeft.style.left = '0'
				} else {
					this.$refs.mapLeft.style.left = '-4rem'
				}
			} else {
				let right = this.$refs.mapRight.style.right
				if (right == '-4.4rem') {
					this.$refs.mapRight.style.right = '0'
				} else {
					this.$refs.mapRight.style.right = '-4.4rem'
				}
			}
		},
		numChange() {
			// console.log(this.dataLangth);
			this.getSetUpEarlyWarning()
		},
		// 获取预警值数据
		async getSetUpEarlyWarning() {
			this.loading = true
			const res = await this.$api.sendPost('/earlyWarning/getAllEarlyWarningAlarm', {})
			if (res.errcode === 0) {
				this.loading = false
				this.tableData = res.data.list
				// console.log('res.data.list', res.data.list);
			} else {
				this.tableData = []
			}
		},
		//获取设施列表
		async getFac() {
			const res = await this.$api.sendGet('/biBridge/getBiBridgeScreenList')
			this.fac = res.data.length
			this.facList = res.data
			// console.log('设施列表', res);
			this.facList.forEach(i => {
				if (i.scenePictureUrl) {
					i.scenePictureUrl = [...i.scenePictureUrl.split(',')]
				}
				i.bridgeSidePictureUrl = i.bridgeSidePictureUrl ? i.bridgeSidePictureUrl.split(',') : null
			})
		},
		//获取在线人员列表
		async getzaixian() {
			let data = {
				pageNum: 1,
				pageSize: 9999
				// accountUuid:this.$store.state.userintfo.accountUuid,
			}
			// console.log(data);
			const res = await this.$api.sendPost('/personalInformation/getPersonalInformation', data)
			// console.log('在线人员列表', res);
			if (res.data && res.data.list.length > 0) {
				this.zaixian = res.data.total
				this.zaixianList = res.data.list
			} else {
				this.zaixian = 0
				this.zaixianList = []
			}
		},
		//获取案件列表
		async getanjuan() {
			let daySart = new Date(new Date(new Date().toLocaleDateString()).getTime()).Format('yyyy-MM-dd HH:mm:ss')
			let dayEnd = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).Format('yyyy-MM-dd HH:mm:ss')
			let data = {
				pageNum: 1,
				pageSize: 9999,
				startTime: daySart,
				endTime: dayEnd
			}
			// console.log(data);
			const res = await this.$api.sendPost('/report/getReport', data)
			// console.log('案件列表', res);
			this.anjuan = res.data.total
			this.anjuanList = res.data.list
			this.anjuanList.forEach(i => {
				// console.log(i.reportPicture);
				// if (i.reportPicture) {
				//   i.reportPicture = [...i.reportPicture.split(",")]
				// }
				i.reportPicture = i.reportPicture ? i.reportPicture.split(',') : null
			})
		},
		//时间
		timechange() {
			Date.prototype.Format = function (fmt) {
				var o = {
					'M+': this.getMonth() + 1, //月份
					'd+': this.getDate(), //日
					'H+': this.getHours(), //小时
					'm+': this.getMinutes(), //分
					's+': this.getSeconds(), //秒
					'q+': Math.floor((this.getMonth() + 3) / 3), //季度
					S: this.getMilliseconds() //毫秒
				}
				if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
				for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
				return fmt
			}
		},
		danxuan(e) {
			if (e) {
				this.shenma = e
			}
			if (this.shenma == '桥梁') {
				this.qar = 1
				this.getFac()
				this.zaixianList = []
				this.anjuanList = []
			} else if (this.shenma == '在线人员') {
				this.qar = 2
				this.getzaixian()
				this.anjuanList = []
				this.facList = []
			} else if (this.shenma == '案卷') {
				this.qar = 3
				this.getanjuan()
				this.zaixianList = []
				this.facList = []
			} else if (this.shenma == '全部') {
				this.qar = 0
				this.getFac()
				this.getzaixian()
				this.getanjuan()
			}
		},
		showVideoList(VideoUrl) {
			console.log('VideoUrl', VideoUrl)
			this.$refs.videolist.open(this.facList, VideoUrl)
		}
	},
	destroyed() {
		clearInterval(this.timmerScrol)
		this.timmerScrol = null
	}
}
</script>
<style lang="scss" scoped>
.Layout {
	width: 100vw;
	height: 100vh;
	position: absolute;
	z-index: 99;
	overflow: hidden;

	.map-left {
		width: 420px;
		height: 880px;
		position: absolute;
		left: 0;
		top: 138px;
		z-index: 99;
		transition: all 1s;

		.map-info {
			position: absolute;
			right: -230px;
			top: 0;
			width: 230px;
			height: 174px;
			background: rgba(3, 67, 79, 0.9);
			border-radius: 4px;
			border: 1px solid #1c9bb1;

			.map-info-title {
				// width: 228px;
				// height: 39px;
				background: #0d333a;
				border-radius: 4px 4px 0px 0px;

				.title-module {
					display: flex;
					align-items: center;
					font-size: 18px;
					font-weight: 400;
					color: #ffffff;
					letter-spacing: 2px;
					padding: 10px;

					.title-module-img {
						width: 14px;
						height: 14px;
						margin-right: 10px;
					}
				}
			}

			.map-info-content {
				width: 100%;
				display: flex;
				justify-content: space-between;
				align-items: center;

				.title-module {
					display: flex;
					align-items: center;
					font-size: 16px;
					font-weight: 800;
					color: #ffffff;
					letter-spacing: 2px;
					padding: 10px;

					// line-height: 27px;
					.title-module-img {
						width: 20px;
						height: 20px;
						margin-right: 10px;
					}
				}

				.map-info-num {
					width: 30px;
					font-size: 18px;
					font-family: SourceHanSansCN-Regular, SourceHanSansCN;
					font-weight: 400;
					color: #2ddbdc;
					// line-height: 27px;
					letter-spacing: 1px;
					margin-right: 20px;
					text-align: left;
				}
			}
		}
	}

	.map-right {
		width: 460px;
		height: 880px;
		position: absolute;
		right: 0;
		top: 138px;
		transition: all 1s;
		z-index: 99;
	}

	// .footer {
	// 	position: absolute;
	// 	bottom: 0;
	// 	left: 0;
	// 	height: 390px;
	// 	background: #153787;
	// 	width: 100%;
	// 	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	// 	border-radius: 4px;
	// 	.translation {
	// 		width: 100%;
	// 		display: flex;
	// 		height: 390px;
	// 		position: absolute;
	// 		bottom: 0;
	// 		transition: all 1s;
	// 	}
	// 	.part {
	// 		color: white;
	// 		width: 25vw;
	// 		padding: 0 40px 0;
	// 		box-sizing: border-box;
	// 		.choose {
	// 			width: 100%;
	// 			height: 22px;
	// 			text-align: center;
	// 			img {
	// 				width: 54px;
	// 				height: 22px;
	// 			}
	// 		}
	// 		.img1 {
	// 			width: 20px;
	// 			height: 20px;
	// 			vertical-align: text-bottom;
	// 			margin-right: 10px;
	// 		}
	// 		.top1 {
	// 			display: flex;
	// 			justify-content: space-between;
	// 			font-size: 18px;
	// 			height: 30px;
	// 			line-height: 30px;
	// 			.el-button {
	// 				width: 90px;
	// 				height: 30px;
	// 				border-radius: 4px;
	// 				border: 1px solid #8ebdff;
	// 				background: transparent;
	// 				text-align: center;
	// 				line-height: 30px;
	// 				color: white;
	// 				padding: 0;
	// 			}
	// 		}
	// 		.top3 {
	// 			height: 90px;
	// 			display: flex;
	// 			.text {
	// 				width: 16px;
	// 				vertical-align: middle;
	// 			}
	// 			.el-image {
	// 				width: 160px;
	// 				height: 90px;
	// 			}
	// 		}
	// 	}
	// 	.button-toleft {
	// 		position: absolute;
	// 		left: 0;
	// 		bottom: 170px;
	// 		cursor: pointer;
	// 		z-index: 99;
	// 	}
	// 	.button-toright {
	// 		position: absolute;
	// 		right: 0;
	// 		bottom: 170px;
	// 		cursor: pointer;
	// 		z-index: 99;
	// 	}
	// }
}

.seamless-warp {
	width: 500px;
	height: 100%;
	overflow: hidden;
	margin-left: 10px;

	.totalImg {
		display: flex;
	}

	.content {
		margin-right: 10px;
	}
}

::v-deep .el-carousel__container {
	height: 220px;
	margin: 10px 0;
}

.warn {
	width: 60px;
	height: 70px;
	background: rgba(21, 55, 135, 0.9);
	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	border-radius: 4px;
	backdrop-filter: blur(2px);
	position: absolute;
	right: 10px;
	top: 118px;
	cursor: pointer;

	.img1 {
		width: 20px;
		height: 20px;
		margin-top: 25px;
	}
}

.page-example3 {
	width: 400px;
	height: 400px;
	overflow: hidden;

	.ul-scoll {
		li {
			margin: 6px;
			padding: 5px;
			background: rgba(198, 142, 226, 0.4);
		}
	}
}

.liebiao {
	width: 420px;
	height: 478px;
	background: rgba(21, 55, 135, 0.9);
	box-shadow: 0px 8px 20px 0px rgba(0, 7, 26, 0.2);
	border-radius: 4px;
	backdrop-filter: blur(2px);
	top: 118px;
	right: 10px;
	position: absolute;
	color: white;
	padding: 20px;
	font-size: 18px;

	.top1 {
		text-align: left;
		height: 18px;
		line-height: 18px;
		margin-bottom: 20px;

		img {
			width: 20px;
			height: 20px;
			vertical-align: text-bottom;
			margin-right: 5px;
		}

		.shuliang {
			margin-left: 5px;
			font-size: 16px;
		}
	}
}

::v-deep .el-table {
	background-color: transparent;

	&:before {
		background-color: transparent;
	}

	width: auto;

	tr {
		background: transparent;
		color: white;
		font-size: 18px;
		line-height: 50px;

		th {
			color: white;
			background: transparent;
			padding: 0;
		}

	}

	td {
		height: 50px;
		line-height: 50px;
		padding: 0;
		font-size: 18px;
	}

	.el-table__header-wrapper {
		background-color: transparent;

		& ::-webkit-scrollbar {
			// width: 8px !important;
			height: 8px;
			background-color: #e4e4e4;
		}
	}

	tbody tr:hover td {
		// background: #0a2f50 !important;
	}

	.el-table__body-wrapper {
		background-color: transparent;
	}

	.cell {
		text-align: center;
		padding: 0;
	}
}

::v-deep .el-table .el-table__cell {
	border: none;
	margin-bottom: 10px;
}

.toRight {
	position: absolute;
	left: -14px;
	width: 12px;
	height: 24px;
	top: 240px;
	cursor: pointer;
}

::v-deep .el-table th.is-leaf {
	/* 去除上边框 */
	border: none;
}

.tow-1 {
	display: flex;
	align-items: center;
}
</style>
